import React from 'react';
import PasswordInvalidIcon from '@/components/Icons/PasswordInvalidIcon';
import PasswordValidIcon from '@/components/Icons/PasswordValidIcon';

/**
 * Displays password strength requirements with inline validation.
 */
export const PasswordRequirements = ({ password }: { password: string }) => {
  const lengthValid = password.length >= 8;
  const uppercaseValid = /[A-Z]/.test(password);
  const lowercaseValid = /[a-z]/.test(password);
  const numberValid = /[0-9]/.test(password);
  const specialCharValid = /[^A-Za-z0-9]/.test(password);

  const renderIcon = (isValid: boolean) =>
    isValid ? <PasswordValidIcon /> : <PasswordInvalidIcon />;

  const requirements = [
    { text: 'At least 8 characters', isValid: lengthValid },
    { text: '1 Lowercase letter (a-z)', isValid: lowercaseValid },
    { text: '1 Special character (!@#$%^&*)', isValid: specialCharValid },
    { text: '1 Uppercase letter (A-Z)', isValid: uppercaseValid },
    { text: '1 number (0-9)', isValid: numberValid }
  ];

  return (
    <div className="mt-8 mb-8 text-xs text-neutral-400 font-light">
      <div className="grid grid-cols-2 gap-x-[20px]">
        <ul className="list-none pl-0 space-y-[4px]">
          {requirements.slice(0, 3).map((req, index) => (
            <li key={index} className="flex items-center">
              <span className="mr-6 inline-flex">{renderIcon(req.isValid)}</span> {req.text}
            </li>
          ))}
        </ul>
        <ul className="list-none pl-0 space-y-[4px]">
          {requirements.slice(3).map((req, index) => (
            <li key={index} className="flex items-center">
              <span className="mr-6 inline-flex">{renderIcon(req.isValid)}</span> {req.text}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
